import React from 'react'
import { IconButton, Button } from '@material-ui/core';
import DoneIcon from '@material-ui/icons/Done';
import ClearIcon from '@material-ui/icons/Clear';
import { makeStyles } from '@material-ui/core/styles';

interface Props {
    meganetLensRxOrderId: number,
    isSubmitting: boolean,
    onCancel: (meganetLensRxOrderId: number) => void,
}

const useStyles = makeStyles(theme => ({
    submit: {
        borderRadius: '50%',
        height: '4em',
        width: '1em',
    },
    root: {
        display: 'flex',
        '& > * + *': {
            marginLeft: theme.spacing(2),
        },
    },
}));

export default ((props) => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Button type="submit" fullWidth disabled={props.isSubmitting} className={classes.submit}>
                <DoneIcon style={{ color: 'green' }} />
            </Button>
            <IconButton aria-label="cancel" onClick={() => props.onCancel(props.meganetLensRxOrderId)}>
                <ClearIcon style={{ color: 'red' }} />
            </IconButton>
        </div>
    )
}) as React.FC<Props>;
